import {
  Button,
  CircularProgress,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import React, { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

type ChildProps = {
  handleClick: () => void;
};

type ConfirmationActionProps = {
  children(state: ChildProps): ReactNode;
  onClick: () => void;
  confirmationTitle?: string;
  isProcessing?: boolean;
  confirmationContent?: string | undefined;
};

const ConfirmationAction = ({
  children,
  onClick,
  isProcessing,
  confirmationTitle = "Are you sure?",
  confirmationContent = undefined,
}: ConfirmationActionProps) => {
  const { t } = useTranslation();
  const [isShowingConfirmationModal, setIsShowingConfirmationModal] = useState(false);

  const handleSubmit = async () => {
    await onClick();
    setIsShowingConfirmationModal(false);
  };

  const handleClick = () => {
    setIsShowingConfirmationModal(true);
  };

  return (
    <>
      {children({ handleClick })}
      <Dialog
        open={isShowingConfirmationModal}
        onClose={() => setIsShowingConfirmationModal(false)}
        fullWidth
      >
        <DialogTitle>{confirmationTitle}</DialogTitle>
        {confirmationContent && (
          <DialogContent>
            {/* @todo improving data security - link only with authorization data */}
            <Button size="small" onClick={() => window.open(confirmationContent)}>{t('Preview PDF')}</Button>
          </DialogContent>
        )}

        <DialogActions>
          <Button onClick={() => setIsShowingConfirmationModal(false)} color="primary">
            {t('no')}
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus disabled={isProcessing}>
            {isProcessing ? <CircularProgress size={23} /> : t('yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationAction;
